import AdAccountRecord from 'automation-ui-action-features/actions/ads-audience-membership/AdAccountRecord';
import { registerMutation, registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const GET_AD_ACCOUNTS_OVERVIEW = registerQuery({
  fieldName: 'adsAccountOverview',
  fetcher: () => http.get('ads/v1/ad-account/user-overview')
});
export const GET_MY_AD_PERMISSIONS = registerQuery({
  fieldName: 'myAdPermissions',
  fetcher: () => http.get('ads/v1/ad-account/my-permissions')
});
export const GET_AUDIENCE_USAGE = registerQuery({
  fieldName: 'audienceUsage',
  fetcher: () => http.get('ads/v1/audience/active-counts').then(response => {
    let contactListAudienceCount = 0;
    Object.values(response.networkAudienceSourceCounts).forEach(sourceCounts => {
      contactListAudienceCount += sourceCounts.HUBSPOT_CONTACT_LIST || 0;
    });
    return contactListAudienceCount;
  })
});
export const GET_WORKFLOW_AUDIENCES = registerQuery({
  fieldName: 'workflowAudiences',
  fetcher() {
    return http.get('ads/v1/audience/workflow-contact-list').then(response => {
      return response.results;
    });
  }
});
export const CREATE_WORKFLOW_AUDIENCE = registerMutation({
  fieldName: 'workflowAudience',
  args: ['accountId', 'adNetwork', 'description', 'euUserConsentCollected', 'name', 'workflowId'],
  fetcher: ({
    accountId,
    adNetwork,
    description,
    euUserConsentCollected,
    name,
    workflowId
  }) => http.post('ads/v1/audience/workflow-contact-list', {
    data: {
      accountId,
      adNetwork,
      description,
      euUserConsentCollected,
      name,
      workflowId
    }
  })
});
export const useAdAccounts = () => {
  var _accountsQuery$data, _permissionsQuery$dat;
  const accountsQuery = useQuery(GET_AD_ACCOUNTS_OVERVIEW);
  const permissionsQuery = useQuery(GET_MY_AD_PERMISSIONS);
  const accounts = (_accountsQuery$data = accountsQuery.data) === null || _accountsQuery$data === void 0 ? void 0 : _accountsQuery$data.adsAccountOverview.accounts;
  const permissions = (_permissionsQuery$dat = permissionsQuery.data) === null || _permissionsQuery$dat === void 0 ? void 0 : _permissionsQuery$dat.myAdPermissions;
  const loading = accountsQuery.loading || permissionsQuery.loading;
  const error = Boolean(accountsQuery.error || permissionsQuery.error);
  const adAccounts = useMemo(() => (accounts || []).map(account => {
    const accountPermissions = permissions === null || permissions === void 0 ? void 0 : permissions.find(perm => perm.adNetwork === account.network && perm.adAccountId === account.accountId);
    return new AdAccountRecord(Object.assign({}, account, accountPermissions === null || accountPermissions === void 0 ? void 0 : accountPermissions.permissions, {
      currentUserHasConnected: !!accountPermissions
      // TODO: Incompatible types for constructor
    }));
  }), [accounts, permissions]);
  const result = useMemo(() => ({
    adAccounts,
    loading,
    error
  }), [adAccounts, loading, error]);
  return result;
};
export function wireWorkflowAudiences(WrappedComponent) {
  return props => {
    const {
      data,
      loading
    } = useQuery(GET_WORKFLOW_AUDIENCES);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      isLoadingWorkflowAudiences: loading,
      workflowAudiences: data && data.workflowAudiences || []
    }));
  };
}